import BarGraph from "./component";

export default BarGraph;
